@if (isSkipApplicationAllowed$ | async) {
  <ng-container *transloco="let t; prefix: 'success'">
    <generic-success-page
      *transloco="let t; prefix: 'success'"
      [title]="t('title')"
      image="eligibilitySuccess"
      [icon]="['fas', 'check']"
      [bigText]="true"
      [currentLanguage]="preferredLanguage$ | async"
      [showLanguageToggler]="true"
      (languageChange)="toggleLanguage($event)"
      [secondaryButton]="t('cancelBtn')"
      (secondaryAction)="close()"
      >
      <p>
        <span>{{ t('applicationAllowedText') }}&nbsp;</span>
      </p></generic-success-page
      >
    </ng-container>
  } @else {
    <ng-container *transloco="let t; prefix: 'success'">
      <generic-success-page
        *transloco="let t; prefix: 'success'"
        [title]="t('title')"
        image="eligibilitySuccess"
        [icon]="['fas', 'check']"
        [bigText]="true"
        [currentLanguage]="preferredLanguage$ | async"
        [showLanguageToggler]="true"
        (languageChange)="toggleLanguage($event)"
        [primaryButton]="t('applyNowBtn')"
        (primaryAction)="submit()"
        [secondaryButton]="t('cancelBtn')"
        (secondaryAction)="close()"
        >
        <p>
          <span>{{ t('residentialPropertyQualifiesText') }}&nbsp;</span>
          <span
            >{{ t('applyNowText') }}
            <a class="link" href="tel:8666341358">(866) 634-1358</a>
          </span>
        </p>
        <ng-container secondary-content>
          <p class="spanish-disclaimer">
            {{ t('programGuidelinesText') }}
            <a class="link" [attr.href]="programGuidelinesLink$ | async" target="_blank">{{
              t('guidelinesLinkText')
            }}</a>
          </p>
          @if (spanishDocsEnabledDisclaimer$ | async) {
            <p class="spanish-disclaimer">
              {{ t('CallToApplyInSpanishDisclaimer') }}
            </p>
          }
          @if (spanishDocsDisabledDisclaimer$ | async) {
            <p class="spanish-disclaimer">
              {{ t('nextStepsDisclaimer') }}
            </p>
          }
          <p class="disclaimer">
            {{ t('disclaimer') }}
          </p>
        </ng-container>
      </generic-success-page>
    </ng-container>
  }

  <!-- Default/Residential success page-->
